import * as React from 'react';
import Pdf from '@payscale/payscale-shared-ui/lib/Pdf/Pdf';
import { CompReportCoverPage } from 'nomst/Components/CompReport/compReportCoverPage';
import { CompReportCompPage } from 'nomst/Components/CompReport/compReportCompPage';
import { compMemoStore } from 'utils/MobxDataManager/singletons';
import { observer } from 'mobx-react';
import './employeeCompReport.scss';

const EmployeeCompReport = (): React.ReactElement => {
    if(compMemoStore.employeeCompData) {
        return (
            <Pdf className="employee-comp-report">
                <CompReportCoverPage employeeName={compMemoStore.employeeCompData.displayName} />
                <CompReportCompPage
                    employee={compMemoStore.employeeCompData}
                    configuration={compMemoStore.configuration}
                />
            </Pdf>
        );
    } else {
        return <></>;
    }
};

export default observer(EmployeeCompReport);